import isReact from 'is-react';
export function whenMapMetricsToPropsIsFunction(mapMetricsToProps) {
  return typeof mapMetricsToProps === 'function' ? mapMetricsToProps : undefined; //eslint-disable-line no-undefined
}

export function whenMapMetricsToPropsIsMissing(mapMetricsToProps) {
  return !mapMetricsToProps ? function (metrics) {
    return metrics;
  } : undefined; //eslint-disable-line no-undefined
}

export function whenMapMetricsToPropsIsAComponent(mapMetricsToProps) {
  return isReact.component(mapMetricsToProps) ? function (metrics) {
    return metrics;
  } : undefined; //eslint-disable-line no-undefined
}

export default [whenMapMetricsToPropsIsFunction, whenMapMetricsToPropsIsMissing, whenMapMetricsToPropsIsAComponent];